import { Component, OnInit } from '@angular/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { INT_WFROUTETYPE_TYPE_ACTIONS, WFROUTETYPE_TYPE_ACTIONS } from "app/shared/actions/actions.constants";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { WorkflowService } from 'app/services/workflow.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { routetypesdto } from 'app/models/routetypesdto';
import { AuthWebService } from 'app/services/authweb.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wfroute-type',
  templateUrl: './wfroute-type.component.html',
  styleUrls: ['./wfroute-type.component.scss']
})
export class WFRouteTypeComponent implements OnInit {
  routetypesdto: routetypesdto = new routetypesdto;
  routetypes: any = [];
  selectedData: any = null;
  selectedStatusData: any = null;
  isLoading: boolean = false;
  lblHeading = "Manage Route Type";
  user: any = {};
  mode:any = 'Add';

  wfStatusTypeActions = INT_WFROUTETYPE_TYPE_ACTIONS;

  constructor(private service: WorkflowService, private toaster: ToastNotificationService, 
    private authWebService: AuthWebService, private datePipe: DatePipe,
    public utility: UtilityServiceService, private dialog: ConfirmDialogService) { }

  ngOnInit(): void {
    this.user = this.authWebService.userData.User
    this.getRouteTypes();
  }

  //#region General
  onChecked(event, item){
    if (event.target.checked) {
      this.selectedStatusData = item;
    } else {
      this.selectedStatusData = null;
    }
  }

  doPermitAction(event: any) {
    const button = document.getElementById("popupButton") as HTMLButtonElement;
    if (event.value == WFROUTETYPE_TYPE_ACTIONS.AddWFRouteType) {
      this.lblHeading = "Add Route Type";
      this.mode = 'Add';
      this.routetypesdto = new routetypesdto;
      button.click();
    } else if (event.value == WFROUTETYPE_TYPE_ACTIONS.DeleteWFRouteType) {
      if(this.selectedStatusData == null){
         this.toaster.error("Please select the record first!","Delete")
       }else{
        this.routetypesdto = this.selectedStatusData;
         this.onDelete();
       }
    } else if (event.value == WFROUTETYPE_TYPE_ACTIONS.EditWFRouteType) {
      this.lblHeading = "Edit Route Type";
      this.mode = 'Edit';
      if(this.selectedStatusData == null){
        this.toaster.error("Please select the record first!","Edit")
      }else{
        this.routetypesdto = this.selectedStatusData;
        button.click();
      }
    }
  }
  //#endregion

  //#region CRUD
  getRouteTypes(){
    this.isLoading = true;
    this.service.getWorkflowRouteType().subscribe(
      (result) => {
        this.routetypes = result;
        this.isLoading = false;
      },
      (error) => {
        this.toaster.error(
          "Failed to load route types. Please try again",
          "Workflow Status"
        );
        this.isLoading = false;
      }
    );

  }

  onAdd(){

    if(this.routetypes.find(x=>x.name==this.routetypesdto.name)){
      this.toaster.error("Route Type already exists!","Route Type");
      return;
    }

    if(this.routetypes.find(x=>x.code==this.routetypesdto.code)){
      this.toaster.error("Code already exists!","Route Type");
      return;
    }

    this.routetypesdto.usercreated = this.user.Id;
    this.routetypesdto.datecreated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.routetypesdto.userupdated = this.user.Id;
    this.routetypesdto.dateupdated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.routetypesdto.deletedyn = false;

    this.isLoading = true;
    this.service.addWorkflowRouteType(this.routetypesdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Route Type successfully added","Route Type");
        this.getRouteTypes();
      },
      (error) => {
        this.toaster.error(
          "Failed to save action. Please try again",
          "Workflow Route Type"
        );
        this.isLoading = false;
      }
    );
  }

  onUpdate(){

    if(this.routetypes.find(x=>x.name==this.routetypesdto.name && x.routetypesid != this.routetypesdto.routetypesid)){
      this.toaster.error("Route Type already exists!","Route Type");
      return;
    }

    if(this.routetypes.find(x=>x.code==this.routetypesdto.code && x.routetypesid != this.routetypesdto.routetypesid)){
      this.toaster.error("Code already exists!","Route Type");
      return;
    }

    this.isLoading = true;
    this.service.updateWorkflowRouteType(this.routetypesdto.routetypesid, this.routetypesdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Route Type successfully updated","Route Type");
        this.getRouteTypes();
      },
      (error) => {
        this.toaster.error(
          "Failed to update action. Please try again",
          "Workflow Route Type"
        );
        this.isLoading = false;
      }
    );
  }

  onDelete(){
    this.dialog.confirmThis(`Are you sure you want to delete this action.`,
    () => {
      this.isLoading = true;      
      this.service.deleteWorkflowRouteType(this.routetypesdto.routetypesid).subscribe(
        (result) => {
          this.toaster.success("Route Type successfully deleted","Route Type");
          this.getRouteTypes();
        },
        (error) => {
          this.toaster.error(
            "Failed to update action. Please try again",
            "Workflow Route Type"
          );
          this.isLoading = false;
        }
      );
    },
    () => {
      this.isLoading = false;
      return;
    }
  );

  }
  //#endregion
}
